const MessageCell = ({ status, message }) => {
    if (!message || status !== 'failed') return '-'

    return <p className="mb-0" title={message}>{message.substring(0, 20)}..</p>
}

export default MessageCell